import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { ModalService } from "src/app/service/modal-service";
import { EisGridComponent } from "../eis-grid/eis-grid.component";

@Component({
  selector: "app-data-performance-window",
  templateUrl: "./data-performance-window.component.html",
  styleUrls: ["./data-performance-window.component.css"],
})
export class DataPerformanceWindowComponent implements OnInit {
  @ViewChild("gridData") gridData: EisGridComponent;
  @Output() resetEvent = new EventEmitter();
  modalId = "app-perf-modal";

  dataList = [];
  gridColumnDefs = [
    {
      headerName: "Contr Name",
      field: "controllerName",
      width: 140,
      pinned: "left",
    },
    { headerName: "Contr Method", field: "controllerMethod", width: 140 },
    { headerName: "# Seconds", field: "diffTime", width: 120 },
    { headerName: "Rows", field: "rowCount", width: 120 },
    { headerName: "Service Name", field: "serviceName", width: 140 },
    { headerName: "Service Method", field: "serviceMethod", width: 140 },
    { headerName: "Dao Name", field: "daoName", width: 140 },
    { headerName: "Dao Method", field: "daoMethod", width: 120 },
    { headerName: "Start", field: "startTime", width: 120 },
    { headerName: "Stop", field: "stopTime", width: 120 },
  ];

  constructor(private modalService: ModalService) {}

  ngOnInit() {}

  loadWindow(vos) {
    this.dataList = [];
    this.gridData.removeAllRows();
    let i = 1;
    vos.forEach((r) => {
      i++;
      r.id = i;
      this.dataList.push(r);
      console.log(r.controllerName);
      this.gridData.updateRowById(r);
    });
    this.openModal();
  }

  openModal() {
    this.modalService.open(this.modalId);
  }

  closeModal() {
    this.modalService.close(this.modalId);
  }

  reset() {
    this.resetEvent.emit();
  }
}
